import { I18N } from "oc-I18N";
import { MultiselectSvg } from "../../inlinesvgs/MultiselectSvg";

const buttonTitle = I18N("Mehrfachauswahl An/Aus");

export function MultiselectToggle() {
  const on = APP.arrangement.isMultiselecting ? "on" : "off";
  return (
    <button
      className={`svg-button-dotted multiselect-button active ${on}`}
      data-button-key={`multi-select-${on}`}
      title={buttonTitle}
      aria-label={buttonTitle}
      onClick={() => {
        APP.arrangement.isMultiselecting = !APP.arrangement.isMultiselecting;
        APP.logUserAction(
          {
            action: "multiSelectToggle",
            isMultiselecting: APP.arrangement.isMultiselecting,
          },
          { stateChange: false }
        );
        APP.updateUI();
      }}
    >
      <MultiselectSvg />
    </button>
  );
}
